import { render, staticRenderFns } from "./UnassignFleet.vue?vue&type=template&id=6ca574ea&scoped=true"
import script from "./UnassignFleet.vue?vue&type=script&lang=js"
export * from "./UnassignFleet.vue?vue&type=script&lang=js"
import style0 from "./UnassignFleet.vue?vue&type=style&index=0&id=6ca574ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca574ea",
  null
  
)

export default component.exports